<template>

  <el-row :class="bgClass" :gutter="12" justify="center">

    <el-col v-if="isTowerCo() && (totalRequests < stats.actions || stats.assets > 0)" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <el-card header="Assets &amp; Services" class="semi-transparent" shadow="hover">
        <dash-text v-if="totalRequests < stats.actions"  caption="Action" icon="fa fa-asterisk" :value="stats.actions - totalRequests" color="darkgrey" :align="align" :size="size" :caption-size="capSize" />
        <dash-text v-if="stats.assets > 0" caption="Asset" icon="fa fa-cogs" :value="stats.assets" color="slateblue" :align="align" :size="size" :caption-size="capSize" />
        <dash-text v-if="stats.Progress > 0" :caption="permitLabel" no-plural :value="stats.Progress" icon="fa fa-file-alt" color="slategrey" :align="align" :size="size" :caption-size="capSize" />

          <table v-if="stats.services > 0" class="el-table semi-transparent">
            <tr v-if="stats.service5G" class="semi-transparent">
              <td>5G:</td><td><strong>{{stats.service5G}}</strong></td>
            </tr>
            <tr v-if="stats.service4G" class="semi-transparent">
              <td>4G:</td><td><strong>{{stats.service4G}}</strong></td>
            </tr>
            <tr v-if="stats.service3G" class="semi-transparent">
              <td>3G:</td><td><strong>{{stats.service3G}}</strong></td>
            </tr>
            <tr v-if="stats.service2G" class="semi-transparent">
              <td>2G:</td><td><strong>{{stats.service2G}}</strong></td>
            </tr>
            <tr v-if="stats.serviceCMDA" class="semi-transparent">
              <td>CMDA:</td><td><strong>{{stats.serviceCMDA}}</strong></td>
            </tr>
            <tr v-if="stats.serviceHPSA" class="semi-transparent">
              <td>HPSA:</td><td><strong>{{stats.serviceHPSA}}</strong></td>
            </tr>
            <tr v-if="stats.serviceFDD" class="semi-transparent">
              <td>FDD:</td><td><strong>{{stats.serviceFDD}}</strong></td>
            </tr>
            <tr v-if="stats.serviceLTE" class="semi-transparent">
              <td>LTE:</td><td><strong>{{stats.serviceLTE}}</strong></td>
            </tr>
            <tr v-if="stats.serviceTDD" class="semi-transparent">
              <td>TDD:</td><td><strong>{{stats.serviceTDD}}</strong></td>
            </tr>
            <tr v-if="stats.serviceUMTS" class="semi-transparent">
              <td>UMTS:</td><td><strong>{{stats.serviceUMTS}}</strong></td>
            </tr>

          </table>

       </el-card>
     </el-col>


     <el-col v-if="isTowerCo() && (stats.terminatedTelcos > 0 || stats.sharers > 0)" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
       <el-card header="Telcos" class="semi-transparent" shadow="hover">
         <dash-text v-if="stats.sharers > 0" caption="Telco" icon="fa fa-users" :value="stats.sharers" color="darkgrey" :align="align" :size="size" :caption-size="capSize" />
         <dash-text v-if="stats.terminatedSharers > 0"  caption="Terminated" icon="fa fa-user-slash" :value="stats.terminatedSharers" color="indianred" no-plural :align="align" :size="size" :caption-size="capSize" />
        </el-card>
      </el-col>


      <el-col v-if="isTowerCo() && showRequests && (stats.rts > 0 || stats.rtu > 0 || stats.rtb > 0)" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
        <el-card header="Requests" class="semi-transparent" shadow="hover">
          <dash-text v-if="stats.rts > 0" caption="Share" icon="fa fa-share-alt" :value="stats.rts" color="seagreen" :align="align" :size="size" :caption-size="capSize" />
          <dash-text v-if="stats.rtu > 0" caption="Upgrade" icon="fa fa-tools" :value="stats.rtu" color="navy" :align="align" :size="size" :caption-size="capSize" />
          <dash-text v-if="stats.rtb > 0" caption="Backhaul" icon="fa fa-wifi" :value="stats.rtb" color="darkgrey" :align="align" :size="size" :caption-size="capSize" />
         </el-card>
       </el-col>


     <el-col v-if="!isTowerCo() && stats.assets > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
       <el-card header="Assets" class="semi-transparent" shadow="hover">
         <dash-text v-if="stats.assets > 0" caption="Asset" icon="fa fa-cogs" :value="stats.assets" color="slateblue" :align="align" :size="size" :caption-size="capSize" />
        </el-card>
      </el-col>

      <el-col v-if="stats.backhaul > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
        <el-card header="Backaul" class="semi-transparent" shadow="hover">
          <dash-text v-if="stats.backhaul > 0" caption="Provider" icon="fa fa-wifi" :value="stats.backhaul" color="navy" :align="align" :size="size" :caption-size="capSize" />
         </el-card>
       </el-col>

       <el-col v-if="isTowerCo() && stats.tickets > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
         <el-card header="Tickets" class="semi-transparent" shadow="hover">
           <dash-text caption="Total" icon="fa fa-headset" :value="stats.tickets" color="darkorange" :align="align" :size="size" :caption-size="capSize" />
           <dash-text v-if="(stats.ticketCritical > 0 || stats.ticketUrgent > 0)" caption="Priority: Critical | Urgent"  no-plural icon="fa fa-exclamation-circle" :value="Number(stats.ticketCritical) + Number(stats.ticketUrgent)" color="indianred" :align="align" :size="size" :caption-size="ticketCapSize" />
           <dash-text v-if="stats.ticketOverdue > 0" caption="Priority: Overdue" no-plural :value="stats.ticketOverdue"  icon="fa fa-hourglass-end" color="orange" :align="align" :size="size" :caption-size="ticketCapSize" />
           <dash-text v-if="stats.ticketOpen > 0" caption="Status:Open" no-plural :value="stats.ticketOpen" icon="fa fa-folder-open" color="slategrey" :align="align" :size="size" :caption-size="ticketCapSize" />
           <dash-text v-if="stats.ticketWIP > 0" caption="Status: In Progress" no-plural :value="stats.ticketWIP" icon="fa fa-tasks" color="navy" :align="align" :size="size" :caption-size="ticketCapSize" />
           <dash-text v-if="stats.ticketPending > 0" caption="Status: Pending"  no-plural :value="stats.ticketPending" icon="fa fa-clock" color="lightgrey" :align="align" :size="size" :caption-size="ticketCapSize" />
           <dash-text v-if="stats.ticketClosed > 0" caption="Status: Closed" no-plural :value="stats.ticketClosed" icon="fa fa-folder" :align="align" :size="size" :caption-size="ticketCapSize" />
          </el-card>
        </el-col>

        <el-col v-if="isTowerCo() && stats.landlords > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
          <el-card header="Landlord" class="semi-transparent" shadow="hover">
            <dash-text  caption="Landlord" icon="fa fa-home" :value="stats.landlords" color="slategrey" :align="align" :size="size" :caption-size="capSize" />
          </el-card>
        </el-col>


<!--
    <el-col v-if="totalRequests < stats.actions && isTowerCo()" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Action" icon="fa fa-asterisk" :value="stats.actions - totalRequests" color="darkgrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.assets > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Asset" icon="fa fa-cogs" :value="stats.assets" color="slateblue" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.backhaul > 0"  :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Provider" icon="fa fa-wifi" :value="stats.backhaul" color="navy" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.sharers > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Telco" icon="fa fa-users" :value="stats.sharers" color="darkgrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.terminate > 0 && isTowerCo()" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Terminated" icon="fa fa-user-slash" :value="stats.terminate" color="indianred" no-plural :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.landlords > 0 && isTowerCo()" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Landlord" icon="fa fa-home" :value="stats.landlords" color="slategrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="showRequests && stats.rts > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Share" icon="fa fa-share-alt" :value="stats.rts" color="seagreen" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="showRequests && stats.rtu > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Upgrade" icon="fa fa-tools" :value="stats.rtu" color="navy" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="showRequests && stats.rtb > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Backhaul" icon="fa fa-wifi" :value="stats.rtb" color="darkgrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="showRequests && stats.Progress > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
        <dash-text  :caption="permitLabel" no-plural :value="stats.Progress" icon="fa fa-file-alt" color="slategrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.tickets > 0" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Ticket" icon="fa fa-headset" :value="stats.tickets" color="darkorange" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="isTowerCo() && (stats.ticketCritical > 0 || stats.ticketUrgent > 0)" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text  caption="Critical | Urgent"  no-plural icon="fa fa-exclamation-circle" :value="Number(stats.ticketCritical) + Number(stats.ticketUrgent)" color="indianred" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.ticketPending > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text caption="Pending"  no-plural :value="stats.ticketPending" icon="fa fa-clock" color="lightgrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.ticketOpen > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text caption="Open" no-plural :value="stats.ticketOpen" icon="fa fa-folder-open" color="slategrey" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col  v-if="stats.ticketWIP > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text caption="In Progress" no-plural :value="stats.ticketWIP" icon="fa fa-tasks" color="navy" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.ticketOverdue > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg"  :align="media.align">
      <dash-text  caption="Overdue" no-plural :value="stats.ticketOverdue"  icon="fa fa-hourglass-end" color="orange" :align="align" :size="size" :caption-size="capSize" />
    </el-col>

    <el-col v-if="stats.ticketClosed > 0" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" :align="media.align">
      <dash-text caption="Closed" no-plural :value="stats.ticketClosed" icon="fa fa-folder" :align="align" :size="size" :caption-size="capSize" />
    </el-col>
-->
</el-row>

</template>

<script>

import {settings} from '@/components/Data'

export default {

  props: {

    siteId: {
      type: Number,
      required: true
    },

    stats: {
      type: Object,
      default: {}
    },

    small: {
      type: Boolean,
      default: false
    },

    showRequests: {
      type: Boolean,
      default: true
    },

    showShadow: {
      type: Boolean,
      default: false
    }

  },


  computed: {

    hasStats: function () {
      let s = this.st
      return (s.rts || s.rtu || s.rtb  || s.rtd || s.int || s.actions || s.landlords ||
        s.ticketClosed || s.ticketOpen || s.ticketCritical || s.ticketWIP || s.ticketOverdue || s.ticketPending || s.ticketUrgent ||
        s.assets || s.tickets || s.backhaul || s.sharers || s.terminate)
    },

    bgClass: function () {
//      return this.showShadow && this.hasStats ? 'shadow-box' : ''
      return ''
    },

    totalRequests: function () {
      return Number(this.st.rts) + Number(this.st.rtu) + Number(this.st.rtb)
    }

  },



  data () {

    return {
      st: this.stats,
      permitLabel: settings.permitLabel,
      ticketCapSize: this.small ? '0.742em' : '0.852em',
      size: this.small ? '1.2em' : '2em',
      capSize: this.small ? '0.852em' : '1.2em',
      align: 'center',
      media: {xs: 24, sm: 12, md: 8, lg: 4, align: 'center'}
    }

  },
/*
  created () {
    console.log('services', this.stats.services, this.stats.service2G, this.stats.serviceHPSA)

  }
*/
}
</script>

<style scoped>

.shadow-box {
  border-radius: 8.52px;
  background-color: #FFFAFA85;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.0852), 0 6px 20px 0 rgba(0, 0, 0, 0.0852);
}

.semi-transparent {
  border-radius: 8.52px;
  padding: 0.852em;
  background-color: #90939912;
}


</style>
